module.exports = __webpack_public_path__ + "img/4. Simulation.a28b945b.jpg";